import { LoadConfirmationFormValues } from '../schema'
import {
  LoadConfirmationDocumentData,
  LoadConfirmationStop,
} from '../types'

function mapStop(
  stop: NonNullable<LoadConfirmationFormValues['pickups']>[number]
): LoadConfirmationStop {
  return {
    startTime: stop?.startTime ?? '',
    endTime: stop?.endTime ?? '',
    name: stop?.name ?? '',
    address: stop?.address ?? '',
    loadType: stop?.loadType ?? 'FTL',
    loadCount: stop?.loadCount ?? '',
    temperatureValue: stop?.temperatureValue ?? '',
    hazmat: stop?.hazmat ?? '',
    pickupNumber: stop?.pickupNumber ?? '',
    weightValue: stop?.weightValue ?? '',
    notes: stop?.notes ?? '',
    contactName: stop?.contactName ?? '',
    contactPhone: stop?.contactPhone ?? '',
  }
}

export function mapFormToDocument(
  form: LoadConfirmationFormValues,
  loadNumber: string
): LoadConfirmationDocumentData {
  return {
    loadNumber,
    myCompany: {
      name: form.myCompanyName ?? '',
      address: form.myCompanyAddress ?? '',
      issuedBy: form.issuedBy ?? '',
      email: form.myCompanyEmail ?? '',
      phone: form.myCompanyPhone ?? '',
      cell: form.myCompanyCell ?? '',
      afterHoursPhone: form.myCompanyAfterHoursPhone ?? '',
      invoicePodName: form.invoicePodContactName ?? '',
      invoicePodEmail: form.invoicePodEmail ?? '',
      invoicePodPhone: form.invoicePodPhone ?? '',
    },
    carrier: {
      name: form.carrierName ?? '',
      address: form.carrierAddress ?? '',
      dispatchName: form.dispatchName ?? '',
      dispatchEmail: form.dispatchEmail ?? '',
      dispatchPhone: form.dispatchPhone ?? '',
      dispatchCell: form.dispatchCell ?? '',
      dispatchAfterHours: form.dispatchAfterHours ?? '',
    },
    rate: {
      currency: form.currency ?? '',
      baseRate: form.baseRate ?? '',
      detentionCharges: form.detentionCharges ?? '',
      layoverCharges: form.layoverCharges ?? '',
      fuelSurcharge: form.fuelSurcharge ?? '',
      otherCharges: form.otherCharges ?? '',
    },
    pickups: (form.pickups ?? []).map(mapStop),
    deliveries: (form.deliveries ?? []).map(mapStop),
    notes: form.notes ?? '',
  }
}
